import React from 'react';
import api from '../services/api';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Switch, Route, Redirect, Router } from 'react-router-dom'
// import {createBrowserHistory,createHashHistory, createMemoryHistory} from 'history';
// const history = createHashHistory();
class InstitutionSelector extends React.Component {
    constructor(props) {
        super(props);        
        var data = window.sessionStorage.getItem("institutionsList")&&window.sessionStorage.getItem("institutionsList")!="null"?
                    JSON.parse(window.sessionStorage.getItem("institutionsList")).map(function(item){
                        return <MenuItem key={item} value={item} primaryText={item}/>
                    }):
                    [
                        <MenuItem key={null} value={null} primaryText="Carregando escolas..." />
                    ];
        if(window.sessionStorage.getItem("institutionsList")&&window.sessionStorage.getItem("institutionsList")!="null")
            data.unshift(<MenuItem key={null} value={null} primaryText="Todas escolas" />);
        this.state = {
            data: data,
            selectedInstitution: window.sessionStorage.getItem("institution")&&window.sessionStorage.getItem("institution")!="null"?window.sessionStorage.getItem("institution"):null
        };
    }
    componentDidMount() {
        var self = this;
        if(window.sessionStorage.getItem("institutionsList")&&window.sessionStorage.getItem("institutionsList")!="null"){
            setTimeout(function(){self.getData();},10000);
        } else this.getData();        
    }
    componentDidUpdate(prevProps, nextState) {        
    }
    handleChangeInstitution = (e,index,value) => {            
        this.setState({selectedInstitution:value});
        window.sessionStorage.setItem("institution",value);
        // history.push({pathname:"/"})
        window.location.reload();
        // history.push({pathname:window.location.pathname})
    }
    getData() {
        var self = this;
        api.getInstitutions().then((rs) => {
            var aux = [];
            var institutionsList = []
            var aux = rs.response.map(function (item) {                
                if (item._id){
                    institutionsList.push(item._id);
                    return <MenuItem key={item._id} value={item._id} primaryText={item._id} />                    
                }                    
            });
            aux.unshift(<MenuItem key={null} value={null} primaryText="Todas escolas" />);            
            window.sessionStorage.setItem("institutionsList", JSON.stringify(institutionsList));
            this.setState({ data: aux });
        }).catch((error) => {
            console.error(error);
        });
    }
    render() {
        var selected = this.state.selectedInstitution;
        return (
            <div style={{ marginRight: "25px" }}>
                <SelectField
                    value={selected}
                    labelStyle={{ color: "white" }}
                    underlineStyle={{ color: "white" }}
                    onChange={this.handleChangeInstitution}
                    >                    
                    {this.state.data}
                </SelectField>
            </div>

        )
    }
};
export default InstitutionSelector;


// WEBPACK FOOTER //
// ./src/layout/InstitutionSelector.js